import { useEffect } from "react";

const SITE = (process.env.REACT_APP_SITE_URL || "").replace(/\/$/, "");
const BRAND = "BagiPulsa";

const setMeta = (attr, key, value) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!value) {
    if (el) el.remove();
    return;
  }
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", value);
};

const setCanonical = (href) => {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

const setJsonLd = (data) => {
  let el = document.getElementById("ld-page");
  if (!data) {
    if (el) el.remove();
    return;
  }
  if (!el) {
    el = document.createElement("script");
    el.type = "application/ld+json";
    el.id = "ld-page";
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify(data);
};

export const absUrl = (url) => (!url ? "" : /^https?:\/\//i.test(url) ? url : `${SITE}${url}`);

export const useSeo = ({ title, description, path = "/", image, type = "website", jsonLd, noindex = false }) => {
  useEffect(() => {
    const full = title ? (title.includes(BRAND) ? title : `${title} | ${BRAND}`) : BRAND;
    const url = `${SITE}${path}`;
    const img = absUrl(image) || `${SITE}/og-image.jpg`;
    document.title = full;
    setMeta("name", "description", description);
    setMeta("name", "robots", noindex ? "noindex, nofollow" : "index, follow, max-image-preview:large, max-snippet:-1");
    setCanonical(url);
    setMeta("property", "og:type", type);
    setMeta("property", "og:title", full);
    setMeta("property", "og:description", description);
    setMeta("property", "og:url", url);
    setMeta("property", "og:image", img);
    setMeta("name", "twitter:title", full);
    setMeta("name", "twitter:description", description);
    setMeta("name", "twitter:image", img);
    setJsonLd(jsonLd);
  }, [title, description, path, image, type, jsonLd, noindex]);
};
